package org.teddapp.project.ui.settings

import androidx.compose.runtime.staticCompositionLocalOf
import kotlinx.coroutines.flow.StateFlow
import org.teddapp.project.sync.SyncUiState

/**
 * Pont entre le SyncManager (jvmMain / androidMain) et les écrans UI (commonMain).
 *
 * Implémenté typiquement par un wrapper léger autour du SyncManager dans le
 * code de la plateforme. Provisionné via [LocalSyncBindings] au plus haut niveau
 * (main.kt desktop / Application Android).
 *
 * Quand `LocalSyncBindings.current == null`, la section Settings "SYNCHRONISATION"
 * est masquée. Ce qui permet à l'app de tourner sans Supabase configuré.
 */
interface SyncBindings {
    val state: StateFlow<SyncUiState>
    /** URL Supabase configurée (pour affichage UI, ex. SupabaseCard). */
    val projectUrl: String?
    fun onToggle(on: Boolean)
    fun onSyncNow()

    /** Compare table par table le local et le serveur. Sans effet si non pris en charge. */
    fun onCheckRemote() {}
}

val LocalSyncBindings = staticCompositionLocalOf<SyncBindings?> { null }
